module.exports = __webpack_public_path__ + "img/FüßeImSand.5fe73773.jpg";